export const DEFAULT_ASSISTANT_PREFERENCES = {
  language: "English",
};

export const DEFAULT_ASSISTANT_UI_SETTINGS = {
  theme: "light",
  preferences: DEFAULT_ASSISTANT_PREFERENCES,
};
